const idaThresholds=
{
hbMale:130, 
hbFemail:120,
ferritinExclude:150,
ferritinConditional:30,
MCV:82,
TIBC:75,
ironSat:20,
hbRiseIron:10
}

export default idaThresholds

